import { EDocMetadataProps } from '@/components/EDocMetadata';
import {
  ActiveFileType,
  usePaymentDetail,
} from '@/features/approving_invoice_reports/components/PaymentDetailDrawer/context/PaymentDetailContext';
import { useTranslation } from '@/i18n';
import classNames from 'classnames';
import { FC, memo } from 'react';
import styles from '../Details.module.scss';

const cx = classNames.bind(styles);

export type MenuContentProps = {
  onClose: VoidFunction;
  onOpenFileInfo: VoidFunction;
  onDownload: VoidFunction;
  eDocMeta?: EDocMetadataProps;
};

export const MenuContent: FC<MenuContentProps> = memo(
  ({ onOpenFileInfo, onDownload, eDocMeta }) => {
    const { t } = useTranslation();
    const { activeFile } = usePaymentDetail();
    const showFileInfo =
      eDocMeta || activeFile?.type === ActiveFileType.BUSINESS_DOCUMENT;

    return (
      <div className={cx(styles['menu-container'])}>
        <div className={cx(styles['menu-list'])}>
          {showFileInfo && (
            <button
              className={cx(styles['menu-item'])}
              onClick={onOpenFileInfo}
            >
              {t('e_doc_information')}
            </button>
          )}
          <button className={cx(styles['menu-item'])} onClick={onDownload}>
            {t('download')}
          </button>
        </div>
      </div>
    );
  }
);
MenuContent.displayName = 'MenuContent';
